import React, { Component } from 'react';
import ReactTooltip from 'react-tooltip';

import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css'; // Core styles
import 'ag-grid-community/styles/ag-theme-balham.css'; // Optional theme
import './ag-theme-ela.css';

import * as CellRenderers from './AgGridCellRendererComponents';

const moment = require('moment');

const DEFAULT_MIN_WIDTH_CELL = 10;
const DEFAULT_MAX_WIDTH_CELL = 800;

const defaultColDef = {
  resizable: true,
  sortable: true,
  filter: true,
  minWidth: DEFAULT_MIN_WIDTH_CELL,
  maxWidth: DEFAULT_MAX_WIDTH_CELL,
  cellStyle: {
    borderRight: '1px solid #ccc', // Adds a light gray divider
  },
};

const columns = [
  {
    headerName: 'Created On',
    field: 'createDateTime',
    valueFormatter: (params) => {
      // Check if value exists
      if (!params.value) return '';

      // Force timezone conversion by parsing as UTC and converting to local
      // This ensures the date is treated as a specific point in time
      return moment.utc(params.value).local().format('MM/DD/YYYY hh:mm A');
    },
    cellClass: 'x-grid-cell-inner',
    width: 130,
  },
  {
    headerName: 'Created By',
    field: 'createdBy',
    cellClass: 'x-grid-cell-inner',
    width: 133,
  },
  {
    headerName: 'Type',
    field: 'jobHistoryType',
    cellClass: 'x-grid-cell-inner',
    width: 135,
  },
  {
    headerName: 'Detail',
    field: 'description',
    cellRenderer: 'detailCellRenderer',
    cellClass: 'x-grid-cell-inner',
    width: 425,
  },
  {
    headerName: '',
    field: 'editView',
    cellRenderer: 'editViewCellRenderer',
    cellClass: 'x-grid-cell-inner',
    width: 50,
  },
  {
    headerName: '',
    field: 'delete',
    cellRenderer: 'deleteCellRenderer',
    cellClass: 'x-grid-cell-inner',
    width: 30,
  },
];

export class WorkOrderFormTableJobHistory extends Component {
  static displayName = WorkOrderFormTableJobHistory.name;

  constructor(props) {
    super(props);
    this.state = {
      columnWidths: columns.reduce((acc, col) => {
        acc[col.field] = col.width || DEFAULT_MIN_WIDTH_CELL; // Initialize widths
        return acc;
      }, {}),
      isResizing: -1,
      clickCount: 0,
    };
    this.previousSelection = [];
    // Bind methods
    this.onColumnResized = this.onColumnResized.bind(this);
    this.autoSizeUnspecifiedColumns =
      this.autoSizeUnspecifiedColumns.bind(this);
    this.adjustHeaderHeight = this.adjustHeaderHeight.bind(this);
    this.onGridReady = this.onGridReady.bind(this);
    this.onDataLoaded = this.onDataLoaded.bind(this);
  }

  componentDidMount() {
    ReactTooltip.rebuild();
  }

  componentWillUnmount() {}

  autoSizeUnspecifiedColumns = () => {
    const allColumnIds = [];
    this.gridColumnApi.getColumns().forEach((column) => {
      // Check if the width is not set in the column definition
      if (column.getColDef().width === undefined) {
        allColumnIds.push(column.colId);
      }
    });
    if (allColumnIds.length > 0) {
      this.gridColumnApi.autoSizeColumns(allColumnIds, false);
    }
  };

  adjustHeaderHeight = (gridApi) => {
    window.requestAnimationFrame(() => {
      const allColumnHeaders = document.querySelectorAll(
        '.ag-header-cell-text'
      );
      let maxHeight = 0;
      allColumnHeaders.forEach((header) => {
        // Ensure that you have access to the clientHeight property correctly
        if (header.parentElement.clientHeight > maxHeight) {
          maxHeight = header.parentElement.clientHeight;
        }
      });

      // Adding some padding or extra space if necessary
      maxHeight += 10; // Adjust this value based on your CSS and padding needs

      // Directly set the new header height
      gridApi.setHeaderHeight(maxHeight);
    });
  };

  onGridReady = (params) => {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.setState({ gridApiReady: true });
    this.adjustHeaderHeight(params.api);
    this.autoSizeUnspecifiedColumns(false);
  };

  onDataLoaded = (newData) => {
    this.gridApi.setRowData(newData);
    this.autoSizeUnspecifiedColumns(true);
  };

  onColumnResized = (params) => {
    if (params.finished) {
      // Update the state with new column width
      const newWidths = { ...this.state.columnWidths };
      params.columns.forEach((column) => {
        newWidths[column.getColId()] = column.getActualWidth();
      });
      this.setState({ columnWidths: newWidths }, () => {
        // Call adjustHeaderHeight after state update to ensure it uses the latest widths
        this.adjustHeaderHeight(this.gridApi);
      });
    }
  };

  render() {
    const gridOptions = {
      suppressSizeToFit: true,
      columnDefs: columns,
      rowData: this.props.jobHistory,
      context: {
        componentParent: this,
        gridApi: this.gridApi,
        state: this.props.state,
        handleViewJobHistoryFile: this.props.handleViewJobHistoryFile,
        handleNewJobNoteViewClick: this.props.handleNewJobNoteViewClick,
        handleDeleteJobHistory: this.props.handleDeleteJobHistory,
        handleOpenJobFromHistory: this.props.handleOpenJobFromHistory,
      },
      animateRows: true,
      defaultColDef: defaultColDef,
      components: {
        detailCellRenderer: CellRenderers.DetailCellRenderer,
        editViewCellRenderer: CellRenderers.EditViewCellRenderer,
        deleteCellRenderer: CellRenderers.DeleteCellRenderer,
      },
      onColumnResized: this.onColumnResized,
      rowHeight: 20,
      tooltipShowDelay: 0,
      enableBrowserTooltips: true,
    };

    return (
      <div
        className="ag-theme-balham"
        style={{
          width: '100%',
          height: '200px',
        }}
      >
        <AgGridReact
          {...gridOptions}
          onGridReady={this.onGridReady}
          rowSelection={'multiple'}
        />
      </div>
    );
  }
}
